import { render, staticRenderFns } from "./NotificationsPopover.vue?vue&type=template&id=163f4716&scoped=true&lang=pug"
import script from "./NotificationsPopover.vue?vue&type=script&lang=ts"
export * from "./NotificationsPopover.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsPopover.vue?vue&type=style&index=0&id=163f4716&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163f4716",
  null
  
)

export default component.exports